export default __webpack_public_path__ + "static/media/Manager_FAQ.55bfa10d.pdf";